import React, { useState } from "react";
import icon1 from "../../assets/icons/authenticicon.png";
import { baseUrl } from "../../utils/base_url";
import pointer from "../../assets/image/pointer.png";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
const HowItWorks = ({ data, bgcolor }) => {
  const [selectedSection, setSelectedSection] = useState(0);
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  
  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: bgcolor }}
      >
        <div className="container py-5 px-0 contwidth">
          <div
            className="row py-5 gy-5"
            // style={{
            //   padding: _992 ? "0 16px" : "",
            // }}
          >
            <div className="col-md-5">
              <h1
                className="fw700 text-white"
                style={{
                  fontSize: _576
                    ? "30px"
                    : _768
                    ? "35px"
                    : _992
                    ? "35px"
                    : _1200
                    ? "38px"
                    : _1400
                    ? "45px"
                    : _1600
                    ? "50px"
                    : _1700
                    ? "55px"
                    : _1800
                    ? "60px"
                    : "64px",
                }}
              >
                {data?.heading}
              </h1>
              <div
                className="d-flex flex-column gap-5 "
                style={{ marginTop: "7rem" }}
              >
                {data?.usecases?.map((data, idx) => (
                  <OptionView
                    data={data}
                    idx={idx}
                    selectedSection={selectedSection}
                    setSelectedSection={setSelectedSection}
                  />
                ))}
              </div>
            </div>
            <div className="col-md-7 ">
              <div className="d-flex flex-column gap-3 text-white">
                <span
                  className="fw400 lh-sm"
                  style={{
                    fontSize: _576
                      ? "20px"
                      : _768
                      ? "24px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "20px"
                      : _1400
                      ? "20px"
                      : _1600
                      ? "21px"
                      : _1700
                      ? "22px"
                      : _1800
                      ? "24px"
                      : "24px",
                  }}
                >
                  {data?.usecases[selectedSection]?.text_1}
                </span>

                <video
                  className="p-0"
                  key={data?.usecases[selectedSection]?.video?.url}
                  autoPlay
                  loop
                  muted
                  width="100%"
                  height="100%"
                >
                  <source
                    src={`${baseUrl}${data?.usecases[selectedSection]?.video?.url}`}
                    type={data?.usecases[selectedSection]?.video?.mime}
                  />
                  Your browser does not support the video tag.
                </video>
                {/* {data?.usecases[selectedSection]?.image?.url ? (
                  <img
                    src={`${baseUrl}${data?.usecases[selectedSection]?.image?.url}`}
                    alt="usecase"
                    className="w-100 h-100 object-fit-cover"
                  />
                ) : data?.usecases[selectedSection]?.video?.url ? (
                  <video
                    className="w-100 h-100 object-fit-cover"
                    autoPlay
                    loop
                    muted
                  >
                    <source
                      src={`${baseUrl}${data?.usecases[selectedSection]?.video?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : null} */}
                <span
                  className="fw400 lh-sm"
                  style={{
                    fontSize: _576
                      ? "20px"
                      : _768
                      ? "24px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "20px"
                      : _1400
                      ? "20px"
                      : _1500
                      ? "18px"
                      : _1600
                      ? "19px"
                      : _1700
                      ? "20px"
                      : _1800
                      ? "22px"
                      : "24px",
                  }}
                >
                  {data?.usecases[selectedSection]?.text_2}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const OptionView = ({ data, idx, selectedSection, setSelectedSection }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="d-flex align-items-center gap-4 cursor-pointer w-100"
        key={idx}
        onClick={() => setSelectedSection(idx)}
      >
        <img
          src={`${baseUrl}${data?.image?.url}`}
          alt=""
          style={{
            width:
              // _576
              // ? "35px"
              // : _768
              // ? "35px"
              // :
              _992
                ? "40px"
                : _1200
                ? "45px"
                : _1400
                ? "50px"
                : _1600
                ? "55px"
                : _1700
                ? "60px"
                : _1800
                ? "65px"
                : "68.1px",
            height: _992
              ? "40px"
              : _1200
              ? "45px"
              : _1400
              ? "50px"
              : _1600
              ? "55px"
              : _1700
              ? "60px"
              : _1800
              ? "65px"
              : "68.1px",
          }}
        />

        <div
          className="d-flex flex-column gap-1 w-75 pt-2 pb-1 px-2"
          style={
            selectedSection === idx
              ? {
                  borderBottom: "5px solid #459EFF",
                }
              : { borderBottom: "5px solid #FFFFFF" }
          }
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column text-white">
              <span
                className="fw600 lh-sm"
                style={{
                  color: selectedSection === idx ? " #459EFF" : " #FFFFFF",
                  fontSize: _576
                    ? "18px"
                    : _768
                    ? "18px"
                    : _992
                    ? "18px"
                    : _1200
                    ? "18px"
                    : _1400
                    ? "20px"
                    : _1600
                    ? "20px"
                    : _1700
                    ? "20px"
                    : _1800
                    ? "22px"
                    : "22px",
                }}
              >
                {data?.super_heading}
              </span>
              <span
                className="fw800 lh-1"
                style={{
                  color: selectedSection === idx ? " #459EFF" : " #FFFFFF",
                  fontSize: _576
                    ? "25px"
                    : _768
                    ? "25px"
                    : _992
                    ? "25px"
                    : _1200
                    ? "30px"
                    : _1400
                    ? "30px"
                    : _1600
                    ? "35px"
                    : _1700
                    ? "35px"
                    : _1800
                    ? "40px"
                    : "40px",
                }}
              >
                {data?.heading}
              </span>
            </div>

            {selectedSection === idx ? (
              <img src={pointer} style={{ width: "24px", height: "25.64px" }} />
            ) : (
              ""
            )}
          </div>
        </div>

        {/* {selectedSection === idx? <img src={pointer}/>:""} */}
      </div>
    </>
  );
};

export default HowItWorks;
